module.exports = __webpack_public_path__ + "img/logo.8ff91989.svg";